import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Grid3x3, List, Sidebar } from "lucide-react";

export enum MailView {
    LIST = "list",
    GRID = "grid",
    SIDE_LIST = "side-list",
}

interface MailViewToggleProps {
    view: MailView;
    onChange?: (view: MailView) => void;
    hideSideListMode?: boolean;
}

const MailViewToggle = ({
    view,
    onChange,
    hideSideListMode,
}: MailViewToggleProps) => {
    const handleChange = (value: MailView) => {
        onChange?.(value);
    };

    return (
        <ToggleGroup
            className="rounded-xl bg-surface-primary p-1"
            onValueChange={handleChange}
            size="mailView"
            type="single"
            value={view}
            variant="mailView"
        >
            <ToggleGroupItem aria-label="Vue liste" value={MailView.LIST}>
                <List />
            </ToggleGroupItem>
            <ToggleGroupItem aria-label="Vue mosaïque" value={MailView.GRID}>
                <Grid3x3 />
            </ToggleGroupItem>
            {!hideSideListMode && (
                <ToggleGroupItem
                    aria-label="Vue liste latérale"
                    value={MailView.SIDE_LIST}
                >
                    <Sidebar />
                </ToggleGroupItem>
            )}
        </ToggleGroup>
    );
};

export default MailViewToggle;
